var EventManager = /** @class */ (function () {
    function EventManager() {
        this.prefix = 'on_';
        this.listeners = {};
    }
    Object.defineProperty(EventManager, "Instance", {
        get: function () {
            if (this.instance === null || this.instance === undefined) {
                this.instance = new EventManager();
            }
            return this.instance;
        },
        enumerable: true,
        configurable: true
    });
    EventManager.prototype.register = function (eventName, bind, callback) {
        var currentEventName = "" + this.prefix + eventName;
        if (typeof this.listeners[currentEventName] === 'undefined') {
            this.listeners[currentEventName] = [];
        }
        this.listeners[currentEventName].push([bind === null ? this : bind, callback]);
    };
    EventManager.prototype.emit = function (eventName, data) {
        var _this = this;
        if (data === void 0) { data = {}; }
        var currentEventName = "" + this.prefix + eventName;
        if (typeof this.listeners[currentEventName] !== 'undefined') {
            this.listeners[currentEventName].forEach(function (element, index) {
                _this.listeners[currentEventName][index][1].call(_this.listeners[currentEventName][index][1], eventName, data);
            });
        }
    };
    return EventManager;
}());
export { EventManager };



//////////////////
// WEBPACK FOOTER
// ./services/event-manager.service.ts
// module id = 17
// module chunks = 0